import React from "react";
import "./CTA.css";

function CTA() {
  return (
    <section className="cta" id="contact">

      <div className="cta-container">

        {/* LEFT CONTENT */}

        <div className="cta-content">

          <span className="cta-eyebrow">
            LET'S WORK TOGETHER
          </span>

          <h2>
            Ready to
            <br />
            <span>Move Forward?</span>
          </h2>

          <p>
            Whether you are looking for a trusted energy
            partner, maritime support or a tailored
            operational solution, our team is ready to
            talk.
          </p>

          <a
            href="/contact"
            className="cta-button"
          >
            <span>Get In Touch</span>
            <span className="cta-button-arrow">→</span>
          </a>

        </div>


        {/* RIGHT VISUAL */}

        <div className="cta-visual">

          <div className="cta-circle"></div>

          <div className="cta-accent"></div>

          <span className="cta-word">
            STRIDES
          </span>

        </div>

      </div>

    </section>
  );
}

export default CTA;